import React, {Component} from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import ReactAvatarEditor from 'react-avatar-editor'
import Dropzone from 'react-dropzone'
import {Button} from 'reactstrap'
import {acceptedLogoFiles} from '../../utils/uploadFiles'

const propTypes = {
  imageUrl: PropTypes.string,
  imageSaveName:  PropTypes.string,
  saveImageFunction: PropTypes.func,
  editorHeight: PropTypes.number,
  editorWidth: PropTypes.number
}

class ImageCrop extends Component {
  constructor(props) {
    super(props)
    this.state = {
      image: props ? props.imageUrl: null,
      scale: 1,
      imageChanged: false
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.imageChanged && !this.props.saveImageFunction && nextProps.saveImageFunction) {
      this.getImageFileAndSave(nextProps.saveImageFunction)
    }
    if (nextProps.imageUrl && nextProps.imageUrl !== this.props.imageUrl && !this.state.imageChanged) {
      this.setState({ image: nextProps.imageUrl })
    }
  }

  getImageFileAndSave(saveFunc) {
    if (this.editor) {
      const canvasScaledBase64 = this.editor.getImageScaledToCanvas().toDataURL()

      fetch(canvasScaledBase64)
        .then(res => res.blob())
        .then(blob =>  saveFunc(new File([blob], `${this.props.imageSaveName || 'image'}.png`)))
    }
  }

  handleDrop = dropped => {
    this.setState({image: dropped[0]})
  }

  handleImageChange = () => {
    !this.state.imageChanged && this.setState({imageChanged: true})
  }

  setEditorRef = (editor) => this.editor = editor

  render() {
    const dropzoneRef = React.createRef()
    const dropzoneSize = { width: `${this.props.editorWidth + 10}px`, height: `${this.props.editorHeight + 10}px`}
    return (
      <Dropzone
        ref={dropzoneRef}
        accept={acceptedLogoFiles}
        onDrop={this.handleDrop}
        disableClick
        style={dropzoneSize}>
        <div style={{...dropzoneSize, border: this.state.image ? 'none' : 'dashed 2px'}}>
          {this.state.image ?
            <ReactAvatarEditor ref={this.setEditorRef}
              crossOrigin="anonymous"
              image={this.state.image}
              width={this.props.editorWidth}
              height={this.props.editorHeight}
              border={5}
              scale={this.state.scale}
              onLoadSuccess={() => !this.props.imageUrl && this.handleImageChange()}
              onImageChange={_.debounce(this.handleImageChange, 500)}
            /> :
            <p style={{textAlign: 'center'}}>Drop image here</p>
          }
        </div>
        {this.state.image && [<label key='zoom_label' style={{marginRight: '5px'}} htmlFor="scale-range">Zoom:</label>,
          <input key='zoom_input' id="scale-range" type="range" step="0.01" min="0.5" max="5" name="scale" value={this.state.scale}
            onChange={(e) => {
              this.setState({scale: Number(e.target.value)})
            }}/>]}
        <Button color="primary" type="button" size='sm' onClick={() => dropzoneRef.current.open()}>
          {this.state.image ? 'Change image' : 'Add image'}
        </Button>
      </Dropzone>
    )
  }
}

ImageCrop.propTypes = propTypes

export default ImageCrop



// WEBPACK FOOTER //
// ./src/components/Support/ImageCrop.js